import { FC } from 'react';
import { Box, Stack } from '@mui/system';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import styles from './index.module.scss';

export const ForgotPasswordPage: FC = () => (
	<div className={styles.layout}>
		<Box className={styles.card}>
			<Stack className={styles.content}>
				<ForgotPasswordForm />
			</Stack>
		</Box>
	</div>
);
